import ICountry from './ICountry';

export function parseCountry(raw: any): ICountry {
    return {
        iso3: raw.iso3,
        name: raw.name,
    };
}
